import { SurveyElement } from './element';
import { Expose, Type } from 'class-transformer';
import { SurveyMultipleSelectOptions } from './multiple-select-options';

export class SurveyMultipleSelectElement extends SurveyElement {
  @Expose({ name: 'question' })
  title!: string;

  @Expose({ name: 'max_allowed_options_number' })
  maxAllowedOptionsNumber!: number | null;

  @Expose()
  @Type(() => SurveyMultipleSelectOptions)
  options!: SurveyMultipleSelectOptions[];
}
